<h4>{{ 'allDocuments.filters.types.title' | translate }}</h4>
<ng-container *ngIf="filteredDocumentTypes && filteredDocumentTypes.length">
  <div class="document-type-item"
    *ngFor="let documentType of filteredDocumentTypes | slice:0:(showAllTypes ? filteredDocumentTypes.length : 4)">
    <label [for]="documentType.code">
      <p-radioButton name="selectedDocumentType" [value]="documentType" [inputId]="documentType.code"
        [ngModel]="selectedValue" (ngModelChange)="onTypeChange($event)"></p-radioButton>
      {{documentType.label | translate}}
    </label>
  </div>
  <a href="#" class="cursor-pointer" (click)="$event.preventDefault(); toggleShowAllTypes()">
    {{ (showAllTypes ? 'allDocuments.filters.types.showLess' : 'allDocuments.filters.types.showAll') | translate }}
  </a>
</ng-container>
